import { render, staticRenderFns } from "./LabelOption.vue?vue&type=template&id=18a4f6ab&scoped=true&"
import script from "./LabelOption.vue?vue&type=script&lang=js&"
export * from "./LabelOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a4f6ab",
  null
  
)

export default component.exports